import { PlayerStates, Snapshot, Table, TableSnapshotter } from '@ppwr/poker'
import MyFirstGameStepNames from './MyFirstGameStepNames'
import { getMyFirstGamePlayers, MyFirstGameCommunityCards, MyFirstGameStep } from './MyFirstGameUtils'

const MyFirstGameSteps: MyFirstGameStep[] = [
  {
    internalName: MyFirstGameStepNames.default,
    stepperNumber: 0
  },
  {
    internalName: MyFirstGameStepNames.letsBegin,
    stepperNumber: 1,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      return TableSnapshotter.forTable(table)
    }
  },
  {
    internalName: MyFirstGameStepNames.holeAndCommunityCards,
    stepperNumber: 2,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      claudia.lastAction = { action: 'HELLO', amount: 0 }
      leslie.lastAction = { action: 'HOLA', amount: 0 }
      esther.lastAction = { action: 'HI', amount: 0 }
      petra.lastAction = { action: 'HEY', amount: 0 }

      return TableSnapshotter.forTable(table)
    }
  },
  {
    internalName: MyFirstGameStepNames.letsGoFaceUp,
    stepperNumber: 3
  },
  {
    internalName: MyFirstGameStepNames.faceUpNote,
    stepperNumber: 3,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      table.players = [player, claudia, esther, petra, leslie]
      player.rankedHandName = 'Pair'

      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      return TableSnapshotter.forTable(table)
    }
  },
  {
    internalName: MyFirstGameStepNames.rounds,
    stepperNumber: 4
  },
  {
    internalName: MyFirstGameStepNames.roles,
    stepperNumber: 5
  },
  {
    internalName: MyFirstGameStepNames.forcedBets,
    stepperNumber: 5
  },
  {
    internalName: MyFirstGameStepNames.smallBlind,
    stepperNumber: 5,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      table.players = [player, claudia, esther, petra, leslie]
      player.rankedHandName = 'Pair'

      table.board.communityCards = MyFirstGameCommunityCards('predeal')
      table.currentPlayerId = 'claudia'

      claudia.lastAction = { action: 'SMALLBLIND', amount: 50 }
      claudia.chips = 9950

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 50

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.bigBlind,
    stepperNumber: 5,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'esther'

      claudia.lastAction = { action: 'SMALLBLIND', amount: 50 }
      esther.lastAction = { action: 'BIGBLIND', amount: 100 }

      claudia.chips = 9950
      esther.chips = 9900

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 150

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.handRankingsNote,
    stepperNumber: 5
  },
  {
    internalName: MyFirstGameStepNames.preFlopRoundNote,
    stepperNumber: 6
  },
  {
    internalName: MyFirstGameStepNames.preFlopStrategy,
    stepperNumber: 6
  },
  {
    internalName: MyFirstGameStepNames.petraRaises1,
    stepperNumber: 6,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'petra'

      claudia.lastAction = { action: 'SMALLBLIND', amount: 50 }
      esther.lastAction = { action: 'BIGBLIND', amount: 100 }
      petra.lastAction = { action: 'RAISE', amount: 300 }

      claudia.chips = 9950
      esther.chips = 9900
      petra.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 450

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.leslieCalls1,
    stepperNumber: 6,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'leslie'

      claudia.lastAction = { action: 'SMALLBLIND', amount: 50 }
      esther.lastAction = { action: 'BIGBLIND', amount: 100 }
      petra.lastAction = { action: 'RAISE', amount: 300 }
      leslie.lastAction = { action: 'CALL', amount: 300 }

      claudia.chips = 9950
      esther.chips = 9900
      petra.chips = 9700
      leslie.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 750

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.userTurnCall1,
    stepperNumber: 7
  },
  {
    internalName: MyFirstGameStepNames.claudiaFolds,
    stepperNumber: 8,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      esther.lastAction = { action: 'BIGBLIND', amount: 100 }
      petra.lastAction = { action: 'RAISE', amount: 300 }
      leslie.lastAction = { action: 'CALL', amount: 300 }
      player.lastAction = { action: 'CALL', amount: 300 }

      claudia.chips = 9950
      esther.chips = 9900
      petra.chips = 9700
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 1050

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.estherCalls2,
    stepperNumber: 8,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      esther.lastAction = { action: 'CALL', amount: 300 }
      petra.lastAction = { action: 'RAISE', amount: 300 }
      leslie.lastAction = { action: 'CALL', amount: 300 }
      player.lastAction = { action: 'CALL', amount: 300 }
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9700
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 1350

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.firstRoundFinished,
    stepperNumber: 8,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('predeal')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      esther.lastAction = { action: 'CALL', amount: 300 }
      petra.lastAction = { action: 'RAISE', amount: 300 }
      leslie.lastAction = { action: 'CALL', amount: 300 }
      player.lastAction = { action: 'CALL', amount: 300 }
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9700
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 1350

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.theFlop,
    stepperNumber: 9,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9700
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 1350

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.estherPreCheck,
    stepperNumber: 10
  },
  {
    internalName: MyFirstGameStepNames.estherChecks2,
    stepperNumber: 10,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'esther'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      esther.lastAction = { action: 'CHECK', amount: 0 }
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9700
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 1350

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.petraBets2,
    stepperNumber: 10,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'petra'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      esther.lastAction = { action: 'CHECK', amount: 0 }
      petra.lastAction = { action: 'BET', amount: 675 }
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2025

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.leslieFolds,
    stepperNumber: 10,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'leslie'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'CHECK', amount: 0 }
      petra.lastAction = { action: 'BET', amount: 675 }
      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9700

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2025

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.userTurnCall2,
    stepperNumber: 11
  },
  {
    internalName: MyFirstGameStepNames.estherTurnPreFold,
    stepperNumber: 12,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'CHECK', amount: 0 }
      petra.lastAction = { action: 'BET', amount: 675 }
      player.lastAction = { action: 'CALL', amount: 675 }

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9025

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2700

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.estherFolds,
    stepperNumber: 12,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'esther'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded
      petra.lastAction = { action: 'BET', amount: 675 }
      player.lastAction = { action: 'CALL', amount: 675 }

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9025

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2700

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.secondRoundFinished,
    stepperNumber: 12,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('flop')

      table.currentPlayerId = 'esther'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded
      petra.lastAction = { action: 'BET', amount: 675 }
      player.lastAction = { action: 'CALL', amount: 675 }

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9025

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2700

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.theTurn,
    stepperNumber: 13,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('turn')

      table.currentPlayerId = 'esther'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 9025
      leslie.chips = 9700
      player.chips = 9025

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 2700

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.beforePetraBets3,
    stepperNumber: 14
  },
  {
    internalName: MyFirstGameStepNames.petraBets3,
    stepperNumber: 14,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('turn')

      table.currentPlayerId = 'petra'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      petra.lastAction = { action: 'BET', amount: 1350 }

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 7675
      leslie.chips = 9700
      player.chips = 9025

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 4050

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.userTurnCall3,
    stepperNumber: 15
  },
  {
    internalName: MyFirstGameStepNames.thirdRoundFinished,
    stepperNumber: 15,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Pair'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('turn')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      petra.lastAction = { action: 'BET', amount: 1350 }
      player.lastAction = { action: 'CALL', amount: 1350 }

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 7675
      leslie.chips = 9700
      player.chips = 7675

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 5400

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.theRiver,
    stepperNumber: 16,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })
      player.rankedHandName = 'Three of a Kind'

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 7675
      leslie.chips = 9700
      player.chips = 7675

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 5400

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.petraBets4,
    stepperNumber: 16,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded
      petra.lastAction = { action: 'BET', amount: 2700 }

      player.rankedHandName = 'Three of a Kind'

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 7675

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 8100

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.userTurnCall4,
    stepperNumber: 17
  },
  {
    internalName: MyFirstGameStepNames.fourthRoundFinished,
    stepperNumber: 17,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded
      petra.lastAction = { action: 'BET', amount: 2700 }
      player.lastAction = { action: 'CALL', amount: 2700 }

      player.rankedHandName = 'Three of a Kind'

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 4975

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 10800

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.theShowdown,
    stepperNumber: 18,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      player.rankedHandName = 'Three of a Kind'

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 4975

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 10800

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.beforeWinnerNote,
    stepperNumber: 18,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'
      player.rankedHandName = 'Three of a Kind'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 15775

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 10800

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.winnerNote,
    stepperNumber: 19,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'
      player.rankedHandName = 'Three of a Kind'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 15775

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 10800

      return snapshot
    }
  },
  {
    internalName: MyFirstGameStepNames.endCard,
    stepperNumber: 19,
    configureGame: (user): Snapshot => {
      const table = new Table('MyFirstGameTable')
      const { claudia, player, esther, leslie, petra } = getMyFirstGamePlayers({ _id: user._id, name: user.name })

      table.players = [player, claudia, esther, petra, leslie]
      table.board.communityCards = MyFirstGameCommunityCards('river')

      table.currentPlayerId = 'player'
      player.rankedHandName = 'Three of a Kind'

      claudia.lastAction = { action: 'FOLD', amount: 0 }
      claudia.state = PlayerStates.Folded
      leslie.lastAction = { action: 'FOLD', amount: 0 }
      leslie.state = PlayerStates.Folded
      esther.lastAction = { action: 'FOLD', amount: 0 }
      esther.state = PlayerStates.Folded

      claudia.chips = 9950
      esther.chips = 9600
      petra.chips = 4975
      leslie.chips = 9700
      player.chips = 4975

      const snapshot = TableSnapshotter.forTable(table)

      snapshot.table[0].mainPot = 10800

      return snapshot
    }
  }
]

export default MyFirstGameSteps
